import React, { memo } from 'react'
import { BankIcon, RoundCheckBlue } from '../../../../assets/icons'
import { PaymentStatusModal } from './PaymentStatusModal'
import numbro from 'numbro'

interface PayWithBankAccountFlow_PROCESSINGProps {
  subtitle: string
  invoiceTotalAmount: number
  invoiceCompanyName: string
  paymentMethodName: string
  onClose: () => void
}

export const PayWithBankAccountFlow_PROCESSING: React.FC<PayWithBankAccountFlow_PROCESSINGProps> =
  memo(
    ({
      subtitle,
      invoiceTotalAmount,
      invoiceCompanyName,
      paymentMethodName,
      onClose,
    }) => {
      return (
        <PaymentStatusModal
          headerIcon={<RoundCheckBlue style={{ alignSelf: 'center' }} />}
          footer={undefined}
          // eslint-disable-next-line i18next/no-literal-string
          backgroundColor={'white'}
          title={`Payment is Processing`}
          subtitle={`Your payment of $${numbro(invoiceTotalAmount).format({
            thousandSeparated: true,
            mantissa: 2,
          })} to ${invoiceCompanyName} is processing`}
          paymentMethodSubtitle={subtitle}
          paymentMethodName={paymentMethodName}
          paymentMethodIcon={<BankIcon />}
          onClose={onClose}
        />
      )
    },
  )
